import { LegalDoc } from "components/legal/legal.types";

export const LEGAL_DOCS: LegalDoc[] = [{
  id: 'data',
  fileName: 'data_processing_addendum.pdf',
  title: 'Data Processing Addendum',
  description: '',
  keywords: ['Libum', 'Libum legal', 'Libum DPA', 'Libum data processing addendum', 'Libum legal agreements'],
  currentAsOf: 'January 31, 2024',
},{
  id:'poweron-pro',
  fileName: 'end_user_license_agreement-poweron-pro.pdf',
  title: 'End User License Agreement - PowerOn Pro',
  description: '',
  keywords: ['Libum', 'Libum legal', 'PowerOn Pro EULA', 'PowerOn Pro end user license agreement', 'Libum legal agreements'],
  currentAsOf: 'March 13, 2025',
},{
  id:'poweron-pipelines',
  fileName: 'end_user_license_agreement-poweron-pipelines.pdf',
  title: 'End User License Agreement - PowerOn Pipelines',
  description: '',
  keywords: ['Libum', 'Libum legal', 'PowerOn Pipelines EULA', 'PowerOn Pipelines end user license agreement', 'Libum legal agreements'],
  currentAsOf: 'June 23, 2025',
},{
  id: 'msa',
  fileName: 'master_services_agreement.pdf',
  title: 'Master Services Agreement',
  description: '',
  keywords: ['Libum', 'Libum legal', 'Libum MSA', 'Libum master services agreement', 'Libum legal agreements'],
  currentAsOf: 'February 1, 2024',
},{
  id: 'privacy',
  fileName: 'privacy_policy.pdf',
  title: 'Privacy Policy',
  description: '',
  keywords: ['Libum', 'Libum legal', 'Libum privacy policy', 'Libum legal policies'],
  currentAsOf: 'January 17, 2024',
},{
  id: 'sla',
  fileName: 'service_level_agreement.pdf',
  title: 'Service Level Agreement',
  description: '',
  keywords: ['Libum', 'Libum legal', 'Libum SLA', 'Libum service level agreement', 'Libum legal agreements'],
  currentAsOf: 'February 2, 2024',
}];
